<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-date-picker
                            range
                            :range-inline="false"
                            start-label="Período de"
                            end-label="Até"
                            :max-date="additionals.dataAtual"
                            :start-validations="validations.periodo.start"
                            :end-validations="validations.periodo.end"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            @change="unidadeChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.unidades"
                            defaultOptionText="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            @change="localAtendimentoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.locaisAtendimento"
                            defaultOptionText="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.localAtendimentoId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            @change="localAtendimentoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.metodosProducao"
                            label="Método de produção"
                            show-default-option
                            text-field="nome"
                            v-model="model.metodoProducao"
                            value-field="id"
                        />
                    </rkm-col>
                    <rkm-col cols="3">
                        <rkm-form-select
                            @change="medicoChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.usuarios"
                            default-option-text="Todos"
                            label="Medico"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-select
                            @change="origemEntradaChange()"
                            :disabled="!isPeriodoFill"
                            :options="form.origensEntrada"
                            default-option-text="Todas"
                            label="Origem de entrada"
                            show-default-option
                            text-field="nome"
                            v-model="model.origemEntradaId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col>
                        <rkm-form-select
                            :disabled="!isPeriodoFill"
                            :options="form.status"
                            default-option-text="Todos"
                            label="Status"
                            show-default-option
                            text-field="nome"
                            v-model="model.status"
                            value-field="valor"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-0 text-nowrap">
                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="handleBuscar()"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!isPeriodoFill"
                            :label="false"
                            @click="limpar()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
            v-if="exibeResultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                    menu-class="auto-scroll"
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        @change="handleSelectedColumns"
                        :indeterminate="indeterminate"
                        class="mx-2"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="cols"
                        class="mx-2"
                        v-model="selectedCols"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="imprimir()"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="items.length === 0"
                    @click="exportar()"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                class="mt-4"
                :fields="fields"
                :items="items"
                hide-pagination
                :sort-compare="sortCompare"
            >
                <template #afterTable v-if="items.length > 0">
                    <rkm-row>
                        <rkm-col
                            cols="12"
                            class="total"
                        >
                            Total: {{ quantidadeTotal }}
                        </rkm-col>
                    </rkm-row>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { repository, error, data, object, stringCase, formats } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Moment
import moment from 'moment'

// Enums
import metodoProducao from '@/enums/pronto-atendimento/metodoProducao';

export default {
    computed: {
        fields() {

            let fields = [
                { key: 'inicio', label: 'Início do plantão', sortable: true },
                { key: 'fim', label: 'Fim do plantão', sortable: true },
                { key: 'nomeMedico', label: 'Médico', sortable: true },
            ]

            this.selectedCols.map(map => {

                const col = this.cols.find(find => find.value === map)
                fields.push({ key: col.value, label: col.text, sortable: true })
            })

            fields.push(
                { key: 'quantidade', label: 'Quantidade', sortable: true },
            )

            return fields
        },
        validations() {

            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
        isPeriodoFill() {
            return this.model.periodo.start != null && this.model.periodo.end != null
        }
    },
    created() {

        this.repositories = {
            relatorioProducaoMedico: this.getConectaSusRepository('prontoAtendimento.relatorioProducaoMedico'),
            impressao: this.getConectaSusRepository('impressao.prontoAtendimento'),
            export: this.getConectaSusRepository('exportacao.prontoAtendimento'),
        }

        this.load()
    },
    data: () => ({
        quantidadeTotal: 0,
        exibeResultado: false,
        items: [],
        model: null,
        form: null,
        additionals: null,
        indeterminate: false,
        filterDefault: {},
        cols: [
            { value: 'nomeUnidade', text: 'Unidade' },
            { value: 'nomeInfraestrutura', text: 'Local de atendimento' },
        ],
        selectedCols: [],
        enums: { metodoProducao },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'inicio' || key === 'fim') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }

        },
        handleSelectedColumns(selected) {

            if (selected) {

                this.cols.map(col => {

                    this.selectedCols.push(col.value)
                })

            } else {

                this.selectedCols = []
            }
        },
        load() {

            this.setLoading()

            this.repositories.relatorioProducaoMedico.list()
                .then(({ data }) => {

                    this.form = this.clone(data.form)
                    this.model = this.clone(data.model)
                    this.additionals = this.clone(data.additionals)

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.addPeriodoWatch()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addPeriodoWatch() {

            this.$watch('model.periodo', {
                deep: true,
                handler() {

                    this.model.unidadeId = null
                    this.model.localAtendimentoId = null
                    this.model.usuarioId = null
                    this.model.origemEntradaId = null
                    this.model.status = null

                    this.form.unidades = []
                    this.form.locaisAtendimento = []
                    this.form.usuarios = []
                    this.form.origensEntrada = []
                    this.form.status = []

                    const filter = this.getFilter()

                    if (filter) {

                        this.setLoading()

                        this.repositories.relatorioProducaoMedico.list(filter)
                            .then(({ data }) => {

                                this.form = this.clone(data.form);
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        handleBuscar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.items = []

                    this.repositories.relatorioProducaoMedico.index(this.getFilter())
                        .then(({ data }) => {

                            this.items = data.atendimentos
                            this.quantidadeTotal = data.quantidadeTotal
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
                this.exibeResultado = true;
        },
        unidadeChange() {

            this.model.localAtendimentoId = null
            this.model.usuarioId = null
            this.model.origemEntradaId = null
            this.model.status = null

            this.form.locaisAtendimento = []
            this.form.usuarios = []
            this.form.origensEntrada = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioProducaoMedico.list(filter)
                    .then(({ data }) => {

                        this.form.locaisAtendimento = this.clone(data.form.locaisAtendimento)
                        this.form.usuarios = this.clone(data.form.usuarios)
                        this.form.origensEntrada = this.clone(data.form.origensEntrada)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        localAtendimentoChange() {

            this.model.usuarioId = null
            this.model.origemEntradaId = null
            this.model.status = null

            this.form.usuarios = []
            this.form.origensEntrada = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioProducaoMedico.list(filter)
                    .then(({ data }) => {

                        this.form.usuarios = this.clone(data.form.usuarios)
                        this.form.origensEntrada = this.clone(data.form.origensEntrada)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        medicoChange() {

            this.model.origemEntradaId = null
            this.model.status = null

            this.form.origensEntrada = []
            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioProducaoMedico.list(filter)
                    .then(({ data }) => {

                        this.form.origensEntrada = this.clone(data.form.origensEntrada)
                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        origemEntradaChange() {

            this.model.status = null

            this.form.status = []

            const filter = this.getFilter()

            if (filter) {

                this.setLoading()

                this.repositories.relatorioProducaoMedico.list(filter)
                    .then(({ data }) => {

                        this.form.status = this.clone(data.form.status)
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            }
        },
        imprimir() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.impressao.relatorioProducaoMedico(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        exportar() {

            this.$refs.RkmForm.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    const filter = this.getFilterExportPrint()

                    this.repositories.export.exportProducaoMedico(filter)
                        .then(response => {

                            this.download(response)
                        })
                        .finally(() => this.unsetLoading())
                })
        },
        getFilterExportPrint() {

            const filter = this.getFilter()
            const $this = this

            const cols = this.fields.map(function (field) {

                field.key = $this.camelToSnake(field.key)

                return field
            })

            filter.columns = cols

            const unidade = this.form.unidades.find(f => f.id === this.model.unidadeId)
            filter.unidade = unidade ? unidade.nomeFantasia : 'Todas'

            const localAtendimento = this.form.locaisAtendimento.find(f => f.id === this.model.localAtendimentoId)
            filter.local_atendimento = localAtendimento ? localAtendimento.nome : 'Todos'

            const usuario = this.form.usuarios.find(f => f.id == this.model.usuarioId)
            filter.nome_medico = usuario ? usuario.nome : 'Todos'

            const origemEntrada = this.form.origensEntrada.find(f => f.id == this.model.origemEntradaId)
            filter.nome_origem_entrada = origemEntrada ? origemEntrada.nome : 'Todas'

            const status = this.form.status.find(f => f.valor == this.model.status)
            filter.nome_status = status ? status.nome : 'Todos'

            return filter
        },
        getFilter() {

            if (this.isPeriodoFill) {

                const filter = this.clone(this.model)
                filter.periodo.start = this.getFormatedDate(filter.periodo.start, 'DD/MM/YYYY')
                filter.periodo.end = this.getFormatedDate(filter.periodo.end, 'DD/MM/YYYY')

                return this.camelObjectKeysToSnakeRecursive(filter)
            }

            return null
        },
        download(response) {

            const content = new Blob([response.data], {type: response.headers['content-type']})
            const url = URL.createObjectURL(content)
            const link = document.createElement('a')

            link.href = url
            link.target = '_blank'
            link.click()
            link.remove()
        },
        limpar() {
            this.exibeResultado = false;
            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.$refs.RkmForm.resetValidator()
        }
    },
    mixins: [ repository, error, data, object, stringCase, formats ],
    watch: {
        'selectedCols': function (newValue) {

            this.indeterminate = false

            if (newValue.length > 0 && newValue.length != this.cols.length) {

                this.indeterminate = true
            }
        },
        'model': {
            deep: true,
            handler() {
                this.exibeResultado = false;
            }
        }
    }
}
</script>

<style scoped>
    .total {
        text-align: right;
        font-weight: bold;
    }

    .dropdown >>> .auto-scroll {
        max-height: 300px;
        overflow: auto;
    }
</style>